// India
export const language: any = {
  IN: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Australia
  AU: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Vietnam
  VN: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // New Zealand
  NZ: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  // Nepal
  NP: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  MU: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  CA: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  BD: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': false,
    'Android': true
  },
  LK: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  AE: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  KH: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  EG: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Singapore
  SG: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  OM: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  MY: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  PK: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  PH: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  BH: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  JO: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  LB: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  KW: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  IR: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': false,
    'iOS': true,
    'Android': true
  },
  TR: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  KE: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  SA: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Taiwan
  TW: {
    'langVal': [{ lang: 'English', val: 'EN' }, { lang: 'Traditional Chinese', val: 'CHI' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Thailand
  TH: {
    'langVal': [{ lang: 'English', val: 'EN' }, { lang: 'Thai', val: 'THA' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Indonesia
  ID: {
    'langVal': [{ lang: 'English', val: 'EN' }, { lang: 'Indonesian', val: 'IND' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Hong Kong
  HK: {
    'langVal': [{ lang: 'English', val: 'EN' }, { lang: 'Traditional Chinese', val: 'CHI' }, { lang: 'Simplified Chinese', val: 'ZK' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  // Korea
  KR: {
    'langVal': [{ lang: 'English', val: 'EN' }, { lang: 'Korean', val: 'KOR' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  },
  NG: {
    'langVal': [{ lang: 'English', val: 'EN' }],
    'qrCode': true,
    'iOS': true,
    'Android': true
  }
}
